import React from "react";
import { Datagrid, FunctionField, TextField } from "react-admin";
import { CustomDateField } from "../../../../../Components/CustomDateField";
import DataGridActionsButtons from "./DataGridActionsButtons";
import { PbhRequestStatus } from "../../../../../Enums/PbhRequestStatus";
import WarehousePanel from "./WarehousePanel";
import { EnumField } from "../../../../../Components/EnumField";
import RequirementCategoryToolTip from "./RequirementCategoryToolTip";
import PbhWhField from "../../../../../Components/WhFields/PbhWhField";
import { WarehouseType } from "../../../../../Enums/WarehouseType";
import RefNoField from "../../../../../../src/Components/ReferenceFields/RefNoField/RefNoField";
import CopyableTableWrapper from "../../../../../../src/Components/CopyableTableWrapper";

export const RejectionProposalDataGrid = props => {
  const onEdit = (id, basePat, record) => {
    if (basePat == "/pbhrequestremarks/pbhrequestorders/") {
      props?.onCreateRemarks?.(record);
    } else {
      const win: any = window.open(`#/pbhrequestorders/${id}`, "_blank");
      win.focus();
    }
  };
  return (
    <CopyableTableWrapper>
      <Datagrid
        optimized
        {...props}
        classes={{ table: props.classes.datagrid }}
        hasBulkActions={false}
        expand={<WarehousePanel />}
      >
        <DataGridActionsButtons
          label={"Actions"}
          onEdit={onEdit}
          tabValue={PbhRequestStatus.RejectionProposal}
          reloadTabs={props.reloadTabs}
        />
        <RefNoField label="REF NO" />
        <TextField source="customerName" label="CUSTOMER" />
        <TextField source="customerPo" label="CUSTOMER PO" />
        <FunctionField
          sortable={false}
          label="REQUIREMENT CATEGORY"
          render={(record: any) => {
            return <RequirementCategoryToolTip record={record} source={"requirementCategoryText"} />;
          }}
        />
        <EnumField label={"Status"} enumName={"PbhRequestStatus"} source={"requestStatus"} />
        <TextField source="pn" label="PN" />
        <TextField source="pnDescription" label="PN DESCRIPTION" />
        <TextField source="airportCode" label="DESTINATION" />
        <TextField source="acRegistration" label="AC" />
        <CustomDateField source="createdDate" label="REQUEST DATE" showTime />
        <CustomDateField source="requestedDeliveryDate" label="REQUESTED DELIVERY DATE" showTime locales="en-GB" />
        <PbhWhField source="pn" whType={WarehouseType.Wh} label="Wh" />
        <PbhWhField source="pn" whType={WarehouseType.Res} label="Res" />
        <PbhWhField source="pn" whType={WarehouseType.AltPn} label="Alt. Pn" valueSource="count" />
        <PbhWhField source="pn" whType={WarehouseType.Rn} label="Rn" />
        <TextField source="currentPbhNote" label="PBH NOTE" />
        <TextField source="pbhReservedNotes" label="PBH Reserved Note" />
      </Datagrid>
    </CopyableTableWrapper>
  );
};

export default RejectionProposalDataGrid;
